import React 				from 'react';

const LangContext = React.createContext({});

LangContext.displayName = 'LangContext';

export default LangContext;
